import './gallery.css'
import Gallery from 'react-grid-gallery';
import { IMAGES } from './GalleryData';

export const ImageGallery = () => {
    return (
        <>
            <div className='gallery-page'>
                <div className='gallery_wrapper'>
                    <Gallery images={IMAGES} enableImageSelection={false} enableKeyboardInput={true} onClickImage={{}} margin={7.5} backdropClosesModal={true} />
                </div>
            </div>
        </>
    )
}
